export const getParameterByName = (name: string, url: Location) => {
    const uri = (!url) ? window.location.href : url.href;
    /* eslint-disable no-useless-escape */
    const param = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${param}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(uri);
    if (!results || !results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getQueryStringParamValue = (key: string): string => {
    const url = new URL(window.location.href);
    return url.searchParams.get(key) || '';
};

export const getMax = (): string => {
    let max = getQueryStringParamValue('max');
    if (max && max.length) return max;
    max = getQueryStringParamValue('maximum');
    return (max && max.length)
        ? max
        : getQueryStringParamValue('limit');
};

export const getBeta = (): string => {
    return getQueryStringParamValue('beta');
};

export const getZipCode = (): string => {
    const zipCode = getQueryStringParamValue('zipCode');
    return (zipCode && zipCode.length)
        ? zipCode
        : getQueryStringParamValue('zip');
};

export const getZipCodeQueryParam = (): string => {
    const zipCode = getQueryStringParamValue('zipCode');
    return (zipCode && zipCode.length) ? `?zipCode=${zipCode}` : '';
};

export const isZipcodeLessThanFiveCharacters = (zipCodeValue: string): boolean => {
	return zipCodeValue.length < 5;
}

export const isZipcodeIncludeAlphaChar = (zipCodeValue: string) : boolean => {
	return new RegExp(/[a-zA-Z]/).test(zipCodeValue);
}

export const isZipcodeIncludeSpecialChar = (zipCodeValue: string): boolean => {
	return new RegExp( /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~\s]/).test(zipCodeValue);
}

export const isZipCodePrecheckPassed = (zipCodeValue: string) : boolean => {
	if(isZipcodeLessThanFiveCharacters(zipCodeValue)) {
		return false;
	}
	if(isZipcodeIncludeAlphaChar(zipCodeValue)) {
		return false;
	}
	if(isZipcodeIncludeSpecialChar(zipCodeValue)){
		return false;
	}
	return true;
}